var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.946 5.902a1.5 1.5 0 1 0-2.8.245l-3 3a1.5 1.5 0 1 0-.461 2.843l2.735 5.469a1.5 1.5 0 1 0 2.56.803l8.518-4.646a1.5 1.5 0 1 0 .13-2.337l-7.682-5.377zM9.502 17.384l8.517-4.646a1.512 1.512 0 0 1 .035-.64l-7.682-5.377a1.493 1.493 0 0 1-1.519.133l-3 3a1.495 1.495 0 0 1-.274 1.688l2.736 5.47a1.495 1.495 0 0 1 1.187.373z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.4831a696a6e56fab49eb539aefea91e5.svg";
export { ForwardRef as ReactComponent };